/**
 * Refresh the skrollr instance on window load to assure that
 * our calculations are as up to date as they can be.
 */
window.addEventListener( 'load', () => {
	/**
	 * Create a new Skrollr instance.
	 */

	const isBlacklistedPage = document.querySelectorAll(
		'.page-template-template-2-1-explaining-pnh, .page-template-template-5-3-events'
	)

	if ( ! isBlacklistedPage.length ) {

		const s = skrollr.init(
			{
				forceHeight: false
			}
		);

		/**
		 * Destroy our instance of skrollr on mobile devices.
		 * The isMobile() method is defined by a Regex within Skrollr.
		 */
		if ( s.isMobile() ) {
			s.destroy();
		}
		s.refresh();
	}
} );
